/* Injects the goal-net texture into specific homepage sections (by section id),
   placing it on the section's background layer (behind all content). Stock-section
   safe — no theme files edited. Styles come from assets/goal-net.css. */
(function () {
  var TARGETS = [
    { id: 'product_list_1', color: 'rgba(11, 78, 130, 0.10)' },
    { id: 'product_list_PTrDdA', color: 'rgba(11, 78, 130, 0.10)' },
    { id: 'section_heritage', color: 'rgba(11, 78, 130, 0.10)' },
    { id: 'section_YpVwaP', color: 'rgba(11, 78, 130, 0.10)' },
    { id: 'catalog_promo', color: 'rgba(11, 78, 130, 0.10)' },
    { id: 'section_tiles', color: 'rgba(11, 78, 130, 0.10)' }
  ];

  function makeNet(color) {
    var n = document.createElement('span');
    n.className = 'goal-net';
    n.setAttribute('aria-hidden', 'true');
    n.style.setProperty('--gn-color', color);
    return n;
  }

  function findHost(id) {
    // JSON-template sections render as id="shopify-section-template--<n>__<key>"
    return document.getElementById('shopify-section-' + id) ||
      document.querySelector('[id^="shopify-section-"][id$="__' + id + '"]');
  }

  function apply(t) {
    var host = findHost(t.id);
    if (!host || host.dataset.netApplied === 'true') return;
    host.dataset.netApplied = 'true';

    var bg = host.querySelector('.section-background');
    if (bg) {
      // Behind content already — just paint the net over the scheme background.
      if (!bg.style.position) bg.style.position = 'absolute';
      bg.style.overflow = 'hidden';
      bg.appendChild(makeNet(t.color));
      return;
    }

    // No background layer (e.g. transparent custom section): net behind, lift content.
    if (!host.style.position) host.style.position = 'relative';
    var kids = Array.prototype.slice.call(host.children);
    host.insertBefore(makeNet(t.color), host.firstChild);
    for (var i = 0; i < kids.length; i++) {
      if (!kids[i].style.position) kids[i].style.position = 'relative';
      if (!kids[i].style.zIndex) kids[i].style.zIndex = '1';
    }
  }

  function run() { for (var i = 0; i < TARGETS.length; i++) apply(TARGETS[i]); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
